module.exports = "https://s.pinimg.com/webapp/style/images/sendPinAvatar-76x-046bb46a.png";